<div class="twitter-tagcloud  twitter-tagcloud-print-block">
  @if (!(isHandset$ | async)) {
  <div class="mat-subheading-2" fxLayout fxLayoutGap="8px" fxLayoutAlign="start cetner">
    <mat-icon>cloud_circle</mat-icon>
    <div>
      <ng-container *ngTemplateOutlet="pageTitle"></ng-container>
      <ng-container *ngTemplateOutlet="pageDateRenge"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="pageHelp"></ng-container>
    <ng-container *ngTemplateOutlet="pageCSVDownload"></ng-container>
  </div>
  }
  @if (isHandset$ | async) {
  <div class="tagcloud-summary">

    <div class="tagcloud-summary-header">
      <mat-icon>cloud_circle</mat-icon>

      <ng-container *ngTemplateOutlet="pageTitle"></ng-container>

      <ng-container *ngTemplateOutlet="pageHelp"></ng-container>

      <ng-container *ngTemplateOutlet="pageCSVDownload"></ng-container>
    </div>

    <div class="tagcloud-summary-date">
      <ng-container *ngTemplateOutlet="pageDateRenge"></ng-container>
    </div>

  </div>
  }

  <mat-card>
    <mat-card-content>
      <div fxLayout="column">
        <div>
          <div fxLayout fxFlex="1 1 auto" fxLayoutAlign="center center" class="container" #container>
            <div fxLayout fxLayout="row wrap" fxLayoutGap="16px grid"></div>
            @if (!(loading$ | async)) {
            @if (cloudData$ | async; as data) {
            @if (data.length > 0) {
            @if (!(isHandset$ | async)) {
            <ng-container *ngTemplateOutlet="tagCloud; context: { data: data, options: pcOptions }"></ng-container>
            }
            @if (isHandset$ | async) {
            <ng-container *ngTemplateOutlet="spTagCloud; context: { data: data, options: spOptions }"></ng-container>
            }
            } @else {
            <div class="no-product">
              該当データなし
            </div>
            }
            }
            } @else {
            <app-music-note></app-music-note>
            }
          </div>
          @if (!(isHandset$ | async)) {
          @if (!(dataCollectLoading$ | async)) {
          @if (!(dataCollections$ | async)) {
          <img class="datanofix_icon" src="./assets/data_collections.png" />
          } @else {
          <img class="datafix_icon"
               matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
               src="./assets/data_collections.png" />
          }
          } @else {
          <img class="datanofix_icon" src="./assets/data_collections.png" />
          }
          }
        </div>
        @if (isHandset$ | async) {
        <div fxLayout fxFlex="1 1 auto" fxLayoutAlign="end center">
          @if (!(dataCollectLoading$ | async)) {
          @if (!(dataCollections$ | async)) {
          <img class="datanofix_icon" src="./assets/data_collections.png" />
          } @else {
          <img class="datafix_icon"
               matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
               src="./assets/data_collections.png" />
          }
          } @else {
          <img class="datanofix_icon" src="./assets/data_collections.png" />
          }
        </div>
        }
      </div>
    </mat-card-content>
  </mat-card>





  <ng-template #pageTitle>
    <span class="tagcloud-summary-title">Twitter キーワード投稿内容</span>
  </ng-template>

  <ng-template #pageHelp>
    <mat-icon class="help"
              matTooltip="選択期間内に投稿されたTwitterの投稿内容上位50位までのキーワードの集計です。（Brandwatch のサンプリングデータを使用しているため実際のものと乖離がある可能性があります）">help_outline</mat-icon>
  </ng-template>

  <ng-template #pageCSVDownload>
    <app-csv-download [id]="csvId"
                      [fileName]="csvFileName"
                      [csv]="csvData$ | async"
                      [loading]="loading$ | async"
                      [artist]="selectedArtist$ | async"></app-csv-download>
  </ng-template>

  <ng-template #pageDateRenge>
    <span class="date-range">
      {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
      ~
      {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
      期間の集計データ
    </span>
  </ng-template>

  <ng-template #tagCloud let-data="data" let-options="options">
    <div fxLayoutAlign="center center" class="twitter-tagcloud" (window:resize)="onResize('pc')">
      <angular-tag-cloud #tagcloudcomp
                         [data]="data"
                         [width]="pcOptions.width"
                         [height]="pcOptions.height"
                         [overflow]="pcOptions.overflow"
                         [realignOnResize]="pcOptions.realignOnResize"
                         [randomizeAngle]="pcOptions.randomizeAngle"
                         [font]="pcOptions.font"
                         [config]="pcOptions"
                         log="false"></angular-tag-cloud>
    </div>
  </ng-template>

  <ng-template #spTagCloud let-data="data" let-options="options">
    <div fxLayoutAlign="center center" class="twitter-tagcloud" (window:resize)="onResize('sp')">
      <angular-tag-cloud class="sptc"
                         #tagcloudcomp
                         [data]="data"
                         [width]="options.width"
                         [height]="options.height"
                         [overflow]="options.overflow"
                         [realignOnResize]="options.realignOnResize"
                         [randomizeAngle]="options.randomizeAngle"
                         [font]="options.font"
                         [config]="spOptions"
                         log="false"></angular-tag-cloud>
    </div>
  </ng-template>
</div>
